// External deps
import { useContext, useEffect, useRef, useState } from 'react';
import { Formik } from 'formik';
import { Form } from 'react-bootstrap';
import { useLocation, useParams } from 'react-router-dom';

// Internal deps
import { getNotification } from '../../../../services/adminContracts';
import { initialValuesSDS } from '../../../CreateServiceRequest/Constants';
import { useFilesContext } from '../../../../context/FilesProvider';
import LoaderContext from '../../../../context/LoaderProvider';
import MainTitle from '../../../MainTitle/MainTitle';
import useToast from '../../../../hooks/useToast';
import { getMultipleDraft as getDataFromTemplateToEdit } from '../../../../adapters/createServiceRequest/createServiceRequestAdapter';
import ListOfAccordions from '../../../CreateServiceRequest/ServiceForm/ListOfAccordions/ListOfAccordions';
import UbicationForm from '../../../CreateServiceRequest/UbicationForm/UbicationForm';

import validationSchema from './GenerateRequestTemplateUtils.js';
import GenerateRequestTemplateButtons from './GenerateRequestTemplateButtons/GenerateRequestTemplateButtons';

import './GenerateRequestTemplate.scss';

const GenerateRequestTemplate = () => {
  const [showTwoStep, setShowTwoStep] = useState(false);
  const [step, setStep] = useState(1);

  const [notificationOptions, setNotificationOptions] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [deletedServices, setDeletedServices] = useState([]);
  const [isAutocomplete, setIsAutocomplete] = useState(false);
  const form = useRef(null);
  const buttonsRef = useRef(null);
  // isDraw significa que se cargo la info a partir de un borrador de una SDS
  // y cuando viene isDraw en true, deberiamos recibir su id
  // isOwn refere to the request template
  const { previusPath, isDraw, idDraw, onlyVisualizeRequestTemplate, isOwn } = useLocation();

  const { setLoader } = useContext(LoaderContext);
  const { setDataAdjuntos } = useFilesContext();
  const { setNewToast } = useToast();
  // id hace referencia al id de una plantilla, esto lo recibimos si vamos a editar
  // una plantilla
  const { id } = useParams();

  const addDeletedServiceRequest = (serviceRequest) => {
    if (serviceRequest?.serviceRequestId) {
      setDeletedServices((prevState) => [
        ...prevState,
        {
          id: serviceRequest?.serviceRequestId,
          eliminado: true
        }
      ]);
    }
  };

  const fetchNotification = async (idBusinessUnit, contractNumber) => {
    const notification = await getNotification(idBusinessUnit, contractNumber);

    setNotificationOptions(notification.data.opciones);
  };

  const getDataOfTemplate = async (templateId) => {
    try {
      setLoader(true);
      const formatedTemplate = await getDataFromTemplateToEdit(templateId, false, !!id, isDraw);

      if (formatedTemplate?.accordions[0]?.provider?.providers?.length) {
        const providerData = formatedTemplate.accordions[0].provider.providers[0];

        fetchNotification(providerData.businessUnit.id, providerData.contract.nombre);
      }
      form.current.setValues(formatedTemplate);
      const allAttachments = formatedTemplate?.accordions.map((acc) => acc.attachments).flat();

      setDataAdjuntos(allAttachments);
      setLoader(false);
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message || 'Ocurrió un error al intentar recuperar la plantilla'
      });
      setLoader(false);
    }
  };

  useEffect(() => {
    // SI hay id siginifica que estamos en la vista de editar y tenemos que traer los datos
    // El valor isAutoComplete sirve para identificar si una plantilla es para editar o borrador
    // Se la pasamos al ubicationForm y lo usa useUbicationForma para evitar volver a consultar
    // Ademas dependiendo del rol de usuario se pueden solapar los datos de las unidades de negocio
    // Cuando el rol es proveedor notificador puede ver todas las unidades de nnegocio
    // Los demas roles solo pueden ver las unidades de negocio asociados a su usuario
    if (id) {
      getDataOfTemplate(id);
      setIsAutocomplete(true);
    }
    if (isDraw && idDraw) {
      getDataOfTemplate(idDraw);
      setIsAutocomplete(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, isDraw, idDraw]);

  useEffect(() => {
    setDataAdjuntos([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={initialValuesSDS}
        innerRef={form}
        validationSchema={validationSchema}
      >
        {/* eslint-disable-next-line no-unused-vars */}
        {({ values }) => (
          <Form>
            <div className="container">
              <div className="my-4">
                <MainTitle
                  isSDS={false}
                  nombre={
                    onlyVisualizeRequestTemplate
                      ? 'Visualización de plantilla'
                      : 'Crear plantilla de solicitud de servicio'
                  }
                  previusPath={previusPath}
                />
              </div>
              <UbicationForm
                autocompletWells
                disabledAllFields={onlyVisualizeRequestTemplate}
                fatherStep={step}
                id={id}
                includeGenericTypes={false}
                isAutocomplete={isAutocomplete}
                setFatherStep={setStep}
                setShowNextStep={setShowTwoStep}
              />
              {showTwoStep && (
                <ListOfAccordions
                  addDeletedServiceRequest={addDeletedServiceRequest}
                  disabledAllFields={onlyVisualizeRequestTemplate}
                  isAutocomplete={isAutocomplete}
                  notificationOptions={notificationOptions}
                />
              )}
              <div className="gap row justify-content-center" ref={buttonsRef}>
                <GenerateRequestTemplateButtons
                  id={id}
                  isDraft={!!id}
                  isDraw={isDraw}
                  previusPath={previusPath}
                  requestTemplateIsOwn={isOwn}
                  visualizePublicTemplate={onlyVisualizeRequestTemplate}
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default GenerateRequestTemplate;
